<template>
  <div class="content" ref="warterMark">
      <div class="title">电子证件</div>
    <div class="wrapper">
      <div class="logoArea">
        <div class="schoolLogo"></div>
        <div class="schoolMotto">学生证</div>
      </div>
      <div class="contentArea">
        <div class="left">
          <p class="name">姓名：邓斯尹<span class="sex">性别：女</span></p>
          <p class="studentNum">学号：211809152</p>
          <p class="department">系别：人文艺术系</p>
          <p class="major">专业：汉语言文学</p>
          <p class="endDate">有效期：2020年9月至2024年8月</p>
        </div>
        <div class="right">
          <img
            id="headphoto"
            :src="require('@/assets/zhicheng/s-photo.png')"
            alt=""
          />
          <p class="idNum">证件号52118091528</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Watermark from "../../../utils/warterMark";
export default {
  // components: { watermark } ,
  data() {
    return {
      updateTime: "",
    };
  },
  onLoad() {
  },
  created() {
    this.nowTimes();
  },
  mounted() {
     Watermark.set(this.updateTime, this.$refs.warterMark);
  },
  methods: {
    timeFormate(timeStamp) {
      let year = new Date(timeStamp).getFullYear();
      let month =
        new Date(timeStamp).getMonth() + 1 < 10
          ? "0" + (new Date(timeStamp).getMonth() + 1)
          : new Date(timeStamp).getMonth() + 1;
      let date =
        new Date(timeStamp).getDate() < 10
          ? "0" + new Date(timeStamp).getDate()
          : new Date(timeStamp).getDate();
      let hh =
        new Date(timeStamp).getHours() < 10
          ? "0" + new Date(timeStamp).getHours()
          : new Date(timeStamp).getHours();
      let mm =
        new Date(timeStamp).getMinutes() < 10
          ? "0" + new Date(timeStamp).getMinutes()
          : new Date(timeStamp).getMinutes();
      let ss =
        new Date(timeStamp).getSeconds() < 10
          ? "0" + new Date(timeStamp).getSeconds()
          : new Date(timeStamp).getSeconds();
      this.updateTime =
        year + "/" + month + "/" + date + " " + hh + ":" + mm + ":" + ss;
    },
    nowTimes() {
      this.timeFormate(new Date());
    },

    
  },
};
</script>

<style lang="scss" scoped>
uni-page-body {
  height: 100%;
}
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: #1374df;
  width: 100%;
  height: auto;
  min-height: 100vh;
  position: relative;
  .title {
    background: rgb(19, 116, 223);
    color: #fff;
    width: 100%;
    height: 44px;
    line-height: 44px;
    text-align: center;
  }
}

.logo {
  height: 200px;
  width: 200px;
  margin-top: 200px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 50px;
}

.text-area {
  display: flex;
  justify-content: center;
}

// .title {
//   font-size: 36px;
//   color: #8f8f94;
// }
.content .wrapper {
  width: 92%;
  min-height: 32.4%;
  background-color: #fff;
//   position: absolute;
  top: 15px;
  border-radius: 10px;
}
.content .wrapper .logoArea {
  width: 100%;
  margin-top: 13px;
  height: 32px;
  display: inline-flex;
  justify-content: flex-start;
  flex-direction: row;
  position: relative;
}
.content .wrapper .logoArea .schoolLogo {
  width: 204px;
  height: 32px;
  background: url(../../../assets/zhicheng/schoolLogo.png) no-repeat center;
  background-size: auto 100%;
  margin-left: 25px;
}
.content .wrapper .logoArea .schoolMotto {
  width: 106px;
  height: 23px;
  /* background: url(../../static/schoolMotto.png) no-repeat right;
		background-size: auto 100%; */
  color: rgba(23, 145, 181, 1);
  font-size: 19px;
  text-align: center;
  position: absolute;
  right: 0px;
  top: 4px;
}
.content .wrapper .contentArea {
  width: 100%;
  min-height: 138px;
  margin-top: 10px;
  position: relative;
  margin-bottom: 15px;
  /* 		display: flex;
		flex-direction: row;
		justify-content: flex-start; */
}
.content .wrapper .contentArea .left {
  width: 215px;
  height: 100%;
  padding-left: 25px;
  color: rgba(51, 51, 51, 1);
}
.left .name {
  margin-top: 10px;
  position: relative;
}
.left .name span {
  position: relative;
  left: 45px;
}
.left p {
  font-size: 13px;
  margin-top: 5px;
}
.left .endDate {
  position: absolute;
  bottom: 0px;
}
.content .wrapper .contentArea .right {
  width: 88px;
  height: 100%;
  color: rgba(51, 51, 51, 1);
  position: absolute;
  right: 12px;
  top: 0px;
}
.right #headphoto {
  width: 84px;
  height: 115px;
}
.right .idNum {
  font-size: 12px;
  transform: scale(0.8);
  width: 135%;
  position: relative;
  left: -15px;
  white-space: nowrap;
}
</style>